import { render, staticRenderFns } from "./IconDeleteLg.vue?vue&type=template&id=5cd5fccc&"
import script from "./IconDeleteLg.vue?vue&type=script&lang=js&"
export * from "./IconDeleteLg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/src/searchie/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5cd5fccc')) {
      api.createRecord('5cd5fccc', component.options)
    } else {
      api.reload('5cd5fccc', component.options)
    }
    module.hot.accept("./IconDeleteLg.vue?vue&type=template&id=5cd5fccc&", function () {
      api.rerender('5cd5fccc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/icons/IconDeleteLg.vue"
export default component.exports